import Link from 'next/link'
import Fade from 'react-reveal/Fade'

import Button from 'components/hong-kong-dial/Button'
import Header from 'components/hong-kong-dial/Header'
import TESpacer from 'components/hong-kong-dial/Spacer'
import Subheader from 'components/hong-kong-dial/Subheader'

import Accordion from './Accordion'
import { Main, Root, Spacer } from './Footer.style'
import Dial from './dial.svg'
import Diameter from './diameter.svg'
import Material from './material.svg'
import Movement from './movement.svg'

const items = [
  {
    header: 'Case',
    body: (
      <ul>
        <li>CASE SIZE: Diameter 36mm, Lug to Lug Length 43.7mm, Thickness 11.05mm</li>
        <li>LUGS / STRAP SIZE: 22mm</li>
        <li>CASE MATERIAL: 316 stainless steel</li>
        <li>CASE FINISHING: Brushed finish</li>
        <li>CASEBACK: UNIMATIC x The Armoury caseback</li>
        <li>WATER RESISTANCE: 300m = 1000ft = 30atm WR</li>
        <li>CROWN: Alchemical Sun ☉ 8mm screw-down</li>
        <li>LENS DESCRIPTION: 2.2mm thick double domed sapphire</li>
        <li>LENS TREATMENT: Inner side anti-reflective coating</li>
      </ul>
    ),
  },
  {
    header: 'Dial',
    body: (
      <ul>
        <li>DIAL: Blu Notte concentric circles dial</li>
        <li>LUMINOUS: Super-LumiNova C1</li>
        <li>DIAL FEATURES: Cool gray open second rail and dial trims</li>
        <li>HANDS: Blu Notte ladder phantom H+M, reverse lollipop S, cool gray tip</li>
      </ul>
    ),
  },
  {
    header: 'Movement',
    body: (
      <ul>
        <li>CALIBER TYPE: Automatic calibre Sellita SW200-1 b</li>
        <li>CALIBER FREQUENCY: 28800bph</li>
        <li>CALIBER FEATURE: Hacking seconds hand</li>
        <li>CALIBER WINDING: Self-winding / manual winding</li>
        <li>CALIBER JEWELS: 26</li>
        <li>MIDDLE RATE ACCURACY: -20 ~ +30s/day</li>
        <li>POWER RESERVE: Min 38h, typical 41h</li>
        <li>ANTIMAGNETISM: Antimagnetic ≥ 4800 A/m</li>
      </ul>
    ),
  },
  {
    header: 'Strap',
    body: (
      <ul>
        <li>STRAP: Cool gray nylon two-piece strap</li>
        <li>EXTRA STRAP: Blu Notte tapered 22-20mm quick-release two-piece TPU strap</li>
        <li>HARDWARE: Stainless steel brushed hardware signed UNIMATIC</li>
      </ul>
    ),
  },
]

const Footer = () => {
  return (
    <Root>
      <Main>
        <Fade>
          <Header className="text-center">Specifications and Availability</Header>
          <Spacer />
          <div className="w-full grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-12 justify-items-center text-center">
            <div className="max-w-[7.5rem] mx-auto">
              <div className="h-28 px-6">
                <Diameter className="w-full h-auto" />
              </div>
              <Subheader>Diameter</Subheader>
              <p className="block mt-2 uppercase text-sm">36MM</p>
            </div>
            <div className="max-w-[7.5rem] mx-auto">
              <div className="h-28 px-6">
                <Dial className="w-full h-auto" />
              </div>
              <Subheader>Case</Subheader>
              <p className="block mt-2 uppercase text-sm">
                316 Stainless Steel
              </p>
            </div>
            <div className="max-w-[7.5rem] mx-auto">
              <div className="h-28 px-6">
                <Material className="w-full h-auto" />
              </div>
              <Subheader>Dial Material</Subheader>
              <p className="block mt-2 uppercase text-sm">‘Lume’ - Super-LumiNova C1</p>
            </div>
            <div className="max-w-[7.5rem] mx-auto">
              <div className="h-28 px-6">
                <Movement className="w-full h-auto animate-spin-slow" />
              </div>
              <Subheader>Movement</Subheader>
              <p className="block mt-2 uppercase text-sm">SW200-1 b</p>
            </div>
          </div>
          <Spacer />
          <Accordion items={items} />
          <Spacer />
          <Spacer />
          <Header className="text-center">How To Purchase</Header>
          <Spacer />
          <div className="text-center">
            <p className="text-center">
              SOLD OUT
            </p>
            <Spacer />
            <p className="text-center">
              For more information please contact <a href="mailto:nyc@thearmoury.com">nyc@thearmoury.com</a>
            </p>
          </div>
        </Fade>
      </Main>
      <TESpacer />
    </Root>
  )
}

Footer.propTypes = {}

export default Footer
